/* eslint prefer-template:0 */

import isLocal from '../common/isLocal.js'
import joinURL from '../common/joinURL.js'

export default function (window, versions) {
  function getViewerRjsConfig(serviceTopology) {
        //TODO: cancel fallback to staticServerUrl when server is stable
    const scriptsLocation = serviceTopology.scriptsDomainUrl
    const serviceURL = joinURL.bind(null, scriptsLocation, 'services', 'third-party')

    const getIntegrationPath = function () { //eslint-disable-line func-style
      return isLocal(window.santaBase) ?
                '//localhost:4578' :
                '//s3.amazonaws.com/integration-tests-statics/SNAPSHOT/runners'
    }

    return {
            //By default load any module IDs from js/lib
      baseUrl: '/',
            //except, if the module ID starts with "app",
            //load it from the js/app directory. paths
            //config is relative to the baseUrl, and
            //never includes a ".js" extension since
            //the paths config could be for a directory.
      paths: {
        experiment: 'js/plugins/experiment/experiment',
        platformUtils: './node_modules/santa-platform-utils/dist/platformUtils-bundle',
        lodash: serviceURL(`lodash/${versions.lodash}/lodash.min`),
        react: { min: serviceURL(`react/${versions.react}/react-with-addons.min`), source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-with-addons` },
        reactDOM: { min: serviceURL(`react/${versions.react}/react-dom.min`), source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-dom` },
        reactDOMServer: { min: serviceURL(`react/${versions.react}/react-dom-server.min`), source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-dom-server` },
        zepto: { min: serviceURL('zepto/1.2.0/zepto.min'), source: serviceURL('zepto/1.2.0/zepto') },
        speakingurl: serviceURL('speakingurl/speakingurl.min'),
        immutable: { min: serviceURL('immutable/3.6.2/immutable.min'), source: serviceURL('immutable/3.6.2/immutable') },
        mousetrap: serviceURL('mousetrap/1.4.6/mousetrap.min'),
        swfobject: serviceURL('swfobject/2.3.20130521/swfobject.min'),
        TweenMax: { min: serviceURL(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: serviceURL(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
        TweenLite: { min: serviceURL(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: serviceURL(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
        TimelineMax: { min: serviceURL(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: serviceURL(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
        ScrollToPlugin: { min: serviceURL(`tweenmax/${versions.tweenmax}/minified/plugins/ScrollToPlugin.min`), source: serviceURL(`tweenmax/${versions.tweenmax}/uncompressed/plugins/ScrollToPlugin`) },
        DrawSVGPlugin: { min: serviceURL(`tweenmax/${versions.tweenmax}/minified/plugins/DrawSVGPlugin.min`), source: serviceURL(`tweenmax/${versions.tweenmax}/uncompressed/plugins/DrawSVGPlugin`) },
        MorphSVGPlugin: { min: serviceURL(`tweenmax/${versions.tweenmax}/minified/plugins/MorphSVGPlugin.min`), source: serviceURL(`tweenmax/${versions.tweenmax}/uncompressed/plugins/MorphSVGPlugin`) },
        Draggable: { min: serviceURL(`tweenmax/${versions.tweenmax}/minified/utils/Draggable.min`), source: serviceURL(`tweenmax/${versions.tweenmax}/uncompressed/utils/Draggable`) },
        color: serviceURL('color-convert/0.2.0/color.min'),
        hammer: serviceURL('hammerjs/2.0.8/hammer.min'),
        jasmine: serviceURL('jasmine/2.1.3/jasmine'),
        'jasmine-html': serviceURL('jasmine/2.1.3/jasmine-html'),
        'jasmine-boot': serviceURL('jasmine/2.1.3/jasmine-boot'),
        bluebird: { min: serviceURL('bluebird/2.9.4/bluebird.min'), source: serviceURL('bluebird/2.9.4/bluebird') },
        SoundManager: serviceURL('soundmanager2/V2.97a.20150601/soundmanager2-nodebug-jsmin'),
        'date-fns': { min: serviceURL('date-fns/v1.3.0/date_fns.min'), source: serviceURL('date-fns/v1.3.0/date_fns') },
        ajv: { min: serviceURL('ajv/4.8.1/ajv.min'), source: serviceURL('ajv/4.8.1/ajv.bundle') },
        ReactProxy: 'js/vendor/ReactProxy',
        Squire: 'js/vendor/squire/Squire',
        io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
        hot: './node_modules/santa-utils/common/hot/listener',
        patcher: './node_modules/santa-utils/common/hot/patcher',
        fake: 'js/plugins/fake/src/main/fake',
        definition: 'js/plugins/definition/src/main/definition',
        jsonpatch: 'js/vendor/json-patch/json-patch.umd',
        xss: { min: serviceURL('xss/0.2.12/xss.min'), source: serviceURL('xss/0.2.12/xss') },
        immutableDiff: 'js/vendor/immutablejsdiff.min',
        pmrpc: joinURL(scriptsLocation, `services/pm-rpc/${versions.pmrpc}/lib/pm-rpc.min`),
        'ag-grid': { min: serviceURL('ag-grid/6.2.1/dist/ag-grid.min'), source: serviceURL('ag-grid/6.2.1/dist/ag-grid') },
        mobx: { min: 'js/vendor/mobx/2.6.1/mobx.umd.min', source: 'js/vendor/mobx/2.6.1/mobx.umd' },
        'mobx-react': { min: 'js/vendor/mobx/3.5.8/mobx-react.min', source: 'js/vendor/mobx/3.5.8/mobx-react' }
      },
      map: {
        'mobx-react': {
          'react-dom': 'reactDOM'
        }
      },
            // generated
      packages: [{
        name: 'tpaIntegration',
        main: 'tpaIntegration',
        location: getIntegrationPath() + '/tpaIntegration/src/main'
      },
      {
        name: 'wixCodeIntegration',
        main: 'wixCodeIntegration',
        location: getIntegrationPath() + '/wixCodeIntegration/src/main'
      }],
      bundles: null,
      shim: {
        zepto: { exports: '$' },
        color: { exports: 'Color' },
        'jasmine-html': {
          deps: ['jasmine']
        },
        'jasmine-boot': {
          deps: ['jasmine', 'jasmine-html']
        },
        bluebird: { exports: 'bluebird' },
        SoundManager: { exports: 'soundManager' },
        ReactProxy: {
          deps: ['react'],
          exports: 'ReactProxy'
        },
        jsonpatch: { exports: 'jsonpatch' },
        xss: { exports: 'filterXSS' }
      },
      waitSeconds: 0
    }
  }
  return getViewerRjsConfig
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/rjs-config.js